module.exports = __webpack_public_path__ + "static/img/wegovy-card-3.3a8ad8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c25/wegovy-card-3.png
// module id = 8U55
// module chunks = 0